import React from 'react';
import '../../styles/Card.css';

type CardProps = {
  children?: React.ReactNode;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  /** 
   * If true, prevents the card from affecting the page layout by containing overflow.
   * Useful when the card content might expand and push other elements (like a header).
   */
  preventOverflow?: boolean;
};

const Card: React.FC<CardProps> = ({
  children,
  width,
  height,
  style = {},
  preventOverflow = false,
}) => {
  const baseStyle: React.CSSProperties = {
    width: width || 'calc(100% - 64px)',
    height: height || '100%',
    maxHeight: '100%',
    marginBottom: '20px',
    ...style,
  };

  if (!preventOverflow) {
    // ✅ Default behavior (your current scrollable card)
    return (
      <div className="custom-card typer-scroll-container" style={{ ...baseStyle, overflowY: 'auto' }}>
        {children}
      </div>
    );
  }

  // ✅ Overflow-contained behavior (prevents header from being pushed)
  return (
    <div
      className="custom-card"
      style={{
        ...baseStyle,
        overflow: 'hidden', // container doesn't push layout
        position: 'relative',
      }}
    >
      <div
        className="typer-scroll-container"
        style={{
          overflowY: 'auto',
          height: '100%',
          width: '100%',
          position: 'absolute',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Card;

